import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";
import RouteLineUrlKeys from "../../../../../constant/RouteLineUrlKeys";

const useGetRouteLineParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const quarter = searchParams.get(RouteLineUrlKeys.QUARTER) ?? null;

  const handleSelect = useCallback(
    (value: string) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set(RouteLineUrlKeys.QUARTER, value);
        return newParams;
      });
    },
    [setSearchParams],
  );

  return { quarter, handleSelect };
};

export default useGetRouteLineParams;
